export const verbs = {
  gerund: [
    {
      name: "admit",
      example:
        "In&nbsp;court the accused admitted (to) stealing the documents.",
    },
    {
      name: "avoid",
      example: "I&nbsp;always try to&nbsp;avoid driving in&nbsp;the rush hour.",
    },
    {
      name: "be worth",
      example:
        "It&nbsp;isn&rsquo;t worth going to&nbsp;the exhibition. It&rsquo;s really boring.",
    },
    {
      name: "can't help",
      example:
        "We&nbsp;can&rsquo;t help laughing when my&nbsp;dad tries to&nbsp;speak French. His accent is&nbsp;awful!",
    },
    {
      name: "can't stand",
      example:
        "I&nbsp;can&rsquo;t stand talking to&nbsp;people who only talk about themselves.",
    },
    {
      name: "carry on",
      example:
        "We&nbsp;carried on&nbsp;chatting until about 2.00 in&nbsp;the morning.",
    },
    {
      name: "deny",
      example:
        "Miriam denied killing her husband but the jury didn&rsquo;t believe her.",
    },
    {
      name: "enjoy",
      example:
        "I&nbsp;used to&nbsp;enjoy flying, but now&nbsp;I don&rsquo;tow&nbsp;I don&rsquo;t.",
    },
    {
      name: "fancy",
      example: "Do&nbsp;you fancy seeing a&nbsp;film this evening?",
    },
    {
      name: "feel like",
      example: "I&nbsp;don&rsquo;t feel like going out tonight.",
    },
    {
      name: "finish",
      example: "Have you finished writing the report yet?",
    },
    {
      name: "give up",
      example: "Karen has given up&nbsp;eating meat, but she still eats fish.",
    },
    {
      name: "imagine",
      example:
        "I&nbsp;can&rsquo;t imagine living in&nbsp;the country. I&nbsp;think&nbsp;I would get bored after a&nbsp;week.",
    },
    {
      name: "involve",
      example:
        "My&nbsp;boyfriend&rsquo;s job involves travelling at&nbsp;least once a&nbsp;month.",
    },
    {
      name: "keep (on)",
      example:
        "I&nbsp;keep (on) telling my&nbsp;husband to&nbsp;lose some weight, but he&nbsp;just won&rsquo;t listen.",
    },
    {
      name: "look forward to",
      example: "We&nbsp;are really looking forward to&nbsp;seeing you again.",
    },
    {
      name: "mind",
      example:
        "I&nbsp;don&rsquo;t mind doing housework. I&nbsp;find it&nbsp;quite relaxing.",
    },
    {
      name: "object to",
      example:
        "If&nbsp;you object to&nbsp;paying lots of&nbsp;money for clothes, don&rsquo;t go&nbsp;shopping in&nbsp;Ginza, Tokyo.",
    },
    {
      name: "miss",
      example: "Does your father miss working now that he&nbsp;has retired?",
    },
    {
      name: "postpone",
      example:
        "We&rsquo;ll have to&nbsp;postpone going to&nbsp;the beach until the weather improves.",
    },
    {
      name: "practise",
      example:
        "The more you practise speaking English the more fluent you'll get.",
    },
    {
      name: "recommend",
      example:
        "I&nbsp;recommend doing a&nbsp;double-decker bus tour as&nbsp;the best way to&nbsp;see London.",
    },
    {
      name: "regret",
      example:
        "I&nbsp;regret not travelling more before&nbsp;I got my&nbsp;first job.",
    },
    {
      name: "risk",
      example:
        "If&nbsp;I&nbsp;were you, I&nbsp;wouldn&rsquo;t risk walking through the park at&nbsp;night.",
    },
    {
      name: "spend",
      example:
        "I&nbsp;spent half an&nbsp;hour looking for my&nbsp;glasses this morning.",
    },
    {
      name: "stop",
      example:
        "Once I&nbsp;open a&nbsp;box of&nbsp;chocolates, I&nbsp;can&rsquo;t stop eating them.",
    },
    {
      name: "suggest",
      example:
        "A&nbsp;friend of&nbsp;mine suggested visiting London in&nbsp;the autumn.",
    },
  ],
  to: [
    {
      name: "afford",
      example:
        "I&nbsp;can&rsquo;t afford to&nbsp;go&nbsp;on&nbsp;holiday this summer.",
    },
    {
      name: "encourage (smn)",
      example: "I&nbsp;encourage all foreigners to&nbsp;try some baklava.",
    },
    {
      name: "urge (smn)",
      example:
        "I&nbsp;urge you to&nbsp;visit the different communities in&nbsp;New York.",
    },
    {
      name: "persuade (smn)",
      example: "She persuaded&nbsp;us to&nbsp;visit Cork in&nbsp;the spring.",
    },
    {
      name: "advise (smn)",
      example:
        "I&nbsp;advise you to&nbsp;go&nbsp;to&nbsp;the Antipodes festival.",
    },
    {
      name: "agree",
      example:
        "I&nbsp;have agreed to&nbsp;pay David back the money he&nbsp;lent me&nbsp;next week.",
    },
    {
      name: "appear",
      example:
        "The results appear to&nbsp;support the scientist&rsquo;s theory.",
    },
    {
      name: "arrange",
      example: "I&rsquo;ve arranged to&nbsp;meet Sally outside the restaurant.",
    },
    {
      name: "be able",
      example:
        "I&nbsp;won&rsquo;t be&nbsp;able to&nbsp;work for two weeks after the operation.",
    },
    {
      name: "can't wait",
      example:
        "We&nbsp;can&rsquo;t wait to&nbsp;see your new flat&nbsp;&mdash; it&nbsp;sounds fantastic.",
    },
    {
      name: "choose",
      example:
        "I&nbsp;chose to&nbsp;study abroad for a&nbsp;year, and it&rsquo;s the best thing I&rsquo;ve ever done.",
    },
    {
      name: "decide",
      example: "They&rsquo;ve decided to&nbsp;call off the wedding.",
    },
    {
      name: "deserve",
      example:
        "Kim deserves to&nbsp;get the job. She&rsquo;s a&nbsp;very strong candidate.",
    },
    {
      name: "expect",
      example:
        "We&rsquo;re expecting to&nbsp;get our exam results on&nbsp;Friday.",
    },
    {
      name: "happen",
      example:
        "Tom happened to&nbsp;be&nbsp;at&nbsp;Alan&rsquo;s when&nbsp;I called&nbsp;in, so&nbsp;I invited him to&nbsp;our party as&nbsp;well.",
    },
    {
      name: "hesitate",
      example:
        "Don&rsquo;t hesitate to&nbsp;ask a&nbsp;member of&nbsp;staff if&nbsp;you need anything.",
    },
    {
      name: "hope",
      example:
        "I&rsquo;m hoping to&nbsp;set up&nbsp;my&nbsp;own company if&nbsp;I can get a&nbsp;bank loan.",
    },
    {
      name: "learn",
      example:
        "I&nbsp;wish&nbsp;I had learnt to&nbsp;play the guitar when&nbsp;I was younger.",
    },
    {
      name: "be make",
      example:
        "When I&nbsp;was at&nbsp;school, we&nbsp;were made to&nbsp;wear a&nbsp;uniform. It&nbsp;was awful.",
    },
    {
      name: "manage",
      example: "Did you manage to&nbsp;get to&nbsp;the airport in&nbsp;time?",
    },
    {
      name: "offer",
      example:
        "Lucy has offered to&nbsp;give me&nbsp;a&nbsp;lift to&nbsp;the station.",
    },
    {
      name: "plan",
      example:
        "We&rsquo;re planning to&nbsp;have a&nbsp;big party to&nbsp;celebrate.",
    },
    {
      name: "pretend",
      example:
        "I&nbsp;pretended to&nbsp;be&nbsp;enthusiastic, but really&nbsp;I didn&rsquo;t like the idea at&nbsp;all.",
    },
    {
      name: "promise",
      example:
        "Sarah always promises to&nbsp;help me&nbsp;in&nbsp;the kitchen, but she never does.",
    },
    {
      name: "refuse",
      example:
        "My&nbsp;neighbour refused to&nbsp;turn down the music and&nbsp;I had to&nbsp;call the police.",
    },
    {
      name: "seem",
      example:
        "Something seems to&nbsp;be&nbsp;wrong with the washing machine.",
    },
    {
      name: "teach",
      example:
        "Jack&rsquo;s father taught him to&nbsp;drive when he&nbsp;was&nbsp;17.",
    },
    {
      name: "tend",
      example:
        "My&nbsp;boss tends to&nbsp;lose her temper when she&rsquo;s feeling stressed.",
    },
    {
      name: "threaten",
      example:
        "The teacher threatened to&nbsp;call my&nbsp;parents and tell them what&nbsp;I had done.",
    },
    {
      name: "want",
      example:
        "The police want to&nbsp;interview anyone who witnessed the crime.",
    },
    {
      name: "would like",
      example:
        "Would you like to&nbsp;try the dress&nbsp;on? The changing rooms are over there.",
    },
  ],
  empty: [
    {
      name: "can",
      example: "Can you help me&nbsp;carry these suitcases?",
    },
    {
      name: "had better",
      example:
        "You&rsquo;d better leave now if&nbsp;you want to&nbsp;catch that train.",
    },
    {
      name: "let",
      example:
        "Let me&nbsp;pay for coffee&nbsp;&mdash; it&nbsp;must be&nbsp;my&nbsp;turn.",
    },
    {
      name: "make",
      example:
        "Sue makes her two teenagers do&nbsp;the washing-up every evening after dinner.",
    },
    {
      name: "may",
      example:
        "There&rsquo;s a&nbsp;lot of&nbsp;traffic today, so&nbsp;we&nbsp;may be&nbsp;a&nbsp;bit late.",
    },
    {
      name: "might",
      example:
        "It&nbsp;might rain tomorrow, so&nbsp;please bring an&nbsp;umbrella or&nbsp;a&nbsp;raincoat.",
    },
    {
      name: "must",
      example:
        "I&nbsp;must remember to&nbsp;phone Harry&nbsp;&mdash; it&rsquo;s his birthday today.",
    },
    {
      name: "should",
      example:
        "Should we&nbsp;book a&nbsp;table for tomorrow night? It&rsquo;s a&nbsp;very popular restaurant.",
    },
    {
      name: "would rather",
      example:
        "You look tired. Would you rather stay in&nbsp;this evening and watch a&nbsp;film?",
    },
    {
      name: "help",
      example:
        "The organization&nbsp;I work for helps young people to&nbsp;find work abroad.",
    },
  ],
};
